import React from "react";

export default function RightArrowPagination({ onClick,strokeColor = "#667085" }) {
  return (
    <button onClick={onClick} className="rightArrowPagination">
      <svg width="7.5" height="15" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 26L14 14L2 2" stroke={strokeColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  );
}


